// @flow

import React from 'react'

type PropTypes = {
  dashboardUrl: string,
  hidden?: boolean,
}

export default (props: PropTypes) => (
  <div className="host-header__notice a__underline">
    <i className="fa fa-info-circle" />
    <a href={props.dashboardUrl}>
      {props.hidden && (
        <span>
          {i18n.t('page.room.hidden')}
          &nbsp;
        </span>
      )}
      {i18n.t('page.room.edit')}
    </a>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/MySelfRoomBanner/index.jsx